import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import LanguageSelect from "../components/LanguageSelect/LanguageSelect";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import "../auth/auth.scss";

const languageOptions = [
  { value: "en", label: "English (US)", code: "us" },
  { value: "pt", label: "Portuguese", code: "pt" },
];

const AuthLayout = () => {
  const [selectedLanguage, setSelectedLanguage] = useState(languageOptions[0]);
  return (
    <main className="auth-layout-main">
      <Container fluid>
        <Row className="justify-content-center">
          <Col xl={6} className="d-none d-lg-block">
            <picture className="auth-layout-banner d-none d-xl-flex align-items-xl-center justify-content-xl-center assistlink-gradient rounded-4">
              <Image
                className="w-auto h-auto object-fit-cover"
                src="/images/assistlink-logo-white.png"
                alt="Assistlink App Logo White"
              />
            </picture>
          </Col>
          <Col xl={6} lg={8}>
            <LanguageSelect
              selectedLanguage={selectedLanguage}
              setSelectedLanguage={setSelectedLanguage}
            />
            <div className="auth-layout-content d-flex flex-column justify-content-center gap-4">
              <div className="text-center mb-4 d-xl-none">
                <Image
                  width={194}
                  height={40}
                  src="/images/assistlink-logo.png"
                  alt="Assistlink App Logo"
                />
              </div>
              <Outlet />
              <div className="d-flex align-items-center justify-content-between gap-4">
                <Link to="" className="fs-6 text-gray-400 text-decoration-none">
                  Privacy Policy
                </Link>
                <Link to="" className="fs-6 text-gray-400 text-decoration-none">
                  Terms of Use
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </main>
  );
};

export default AuthLayout;
